import { render, staticRenderFns } from "./AmendDeposit.vue?vue&type=template&id=3d51117a"
import script from "./AmendDeposit.vue?vue&type=script&lang=js"
export * from "./AmendDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports